import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";
import Calendar from "./CalendarAlt.png";

export const CalendarAltIcon = ({ title }) => (
  <Icon>
    <img src={Calendar} alt={title} />
  </Icon>
);

CalendarAltIcon.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.shape({}).isRequired
};

CalendarAltIcon.defaultProps = {
  title: "Calendar title"
};

export default withTheme(CalendarAltIcon);
